import React, { useState, useEffect, useCallback } from 'react';
import {
  IconButton, Grid, Typography, Button
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { debounce } from 'lodash';

// components
import { useHistory } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Notification from '../../utils/notification';
import DeleteDialog from '../../components/DeleteDialog';
import TableData from '../../components/TableData';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import useStyles from './styles';
import api from '../../services/api';
import { getError } from '../../utils/getResponseError';
import {
  cnpjMask
} from '../../utils/mask';

export default function Clientes() {
  const history = useHistory();
  const classes = useStyles();
  const [clientes, setClientes] = useState([]);
  const [openDelete, setOpenDelete] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [error, setError] = useState(null);
  const layoutDispatch = useLayoutDispatch();

  useEffect(() => {
    clienteRequest();
  }, [page, search]);

  async function clienteRequest() {
    toggleLoading(layoutDispatch);
    setError(null);
    try {
      const { data } = await api.get(`/cliente?pagina=${page}&nome=${search}`);
      setTotal(data.totalPaginas);
      setClientes(data.dados.map((item) => ({
        ...item,
        cnpj: cnpjMask(item.cnpj)
      })));
      if (page > data.totalPaginas) {
        setPage(1);
      }
    } catch (error) {
      setError(getError(error));
    }
    toggleLoading(layoutDispatch);
  }

  const handleSearch = (query) => {
    setSearch(query);
  };

  const onSearch = useCallback(
    debounce(handleSearch, 500),
    []
  );

  function handlePage(newPage) {
    if (newPage !== page) {
      setPage(newPage);
    }
  }

  function handleDeleteConfirmation(index) {
    setOpenDelete(index.toString());
  }

  function handleCancelDelete() {
    setOpenDelete(null);
  }

  function handleReload() {
    clienteRequest();
  }

  async function handleDelete() {
    const cliente = clientes[openDelete];
    try {
      await api.delete(`/cliente/${cliente.id_cliente}`);
      Notification({
        type: 'shipped',
        message: 'Cliente excluído com sucesso!',
        variant: 'contained',
        color: 'success',
      });
      clienteRequest();
    } catch (error) {
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
    }
    setOpenDelete(null);
  }

  function handleEdit(index) {
    const cliente = clientes[index];
    history.push(`/app/clientes/cadastro/${cliente.id_cliente}`);
  }

  return (
    <>
      <DeleteDialog
        open={!!openDelete}
        handleClose={handleCancelDelete}
        handleConfirm={handleDelete}
        message="Tem certeza que deseja excluir o cliente?"
      />
      <PageTitle
        title="Clientes"
        button={(
          <IconButton
            color="primary"
            aria-label="cadastrar novo cliente"
            className={classes.addButton}
            onClick={() => history.push('/app/clientes/cadastro')}
          >
            <AddIcon />
          </IconButton>
        )}
      />
      {error && (
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}

          >
            <Widget
              disableWidgetMenu
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h6"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Ocorreu um erro ao tentar listar os clientes
              </Typography>
              <Typography
                variant="p"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Mensagem de erro:
                {' '}
                {error}
              </Typography>
              <br />
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginTop: 50
                }}
                onClick={handleReload}
              >
                Tentar novamente
              </Button>
            </Widget>
          </Grid>
        </Grid>
      )}
      {!error && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TableData
              title="Clientes cadastrados"
              columns={[{
                name: 'nome',
                label: 'Nome',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                name: 'email',
                label: 'Email',
                options: {
                  filter: true,
                  sort: false,
                }
              },
              {
                name: 'cnpj',
                label: 'Cnpj',
                options: {
                  filter: true,
                  sort: false,
                }
              }]}
              data={clientes}
              search={onSearch}
              page={page}
              total={total}
              onSetPage={handlePage}
              onCloseSearch={setSearch}
              onEdit={handleEdit}
              onDelete={handleDeleteConfirmation}
              showEdit
              showDelete
              showSearch
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
